import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
// Angular Imports
import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { CookieHelper } from '../../common/cookie-helper';
// import { AccountSummaryModule } from '../accountsummary/account-summary.module';
// import { AcctactvtyModule } from '../acctactvty/acctactvty.module';
// import { FlyoutFeedModule } from '../flyout-feed/flyout-feed.module';
// import { FlyoutTodayModule } from '../flyout-today/flyout-today.module';
import { UserAccountsModule } from '../user-accounts/user-accounts.module';
// This Module's Components
import { FlyoutLoggedinUserComponent } from './flyout-loggedin-user.component';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    // AccountSummaryModule,
    // FlyoutTodayModule,
    ModalModule.forRoot(),
    TabsModule.forRoot(),
    // AcctactvtyModule,
    // FlyoutFeedModule,
    UserAccountsModule
  ],
  providers: [CookieHelper],
  declarations: [FlyoutLoggedinUserComponent],
  exports: [FlyoutLoggedinUserComponent]
})
export class FlyoutLoggedinUserModule {}
